import { PanelInviteTabKey } from '@/components/modals/PanelInviteModal/types'

export const PANEL_INVITE_TAB_KEY: Record<
  PanelInviteTabKey,
  PanelInviteTabKey
> = {
  inviteDetails: 'inviteDetails',
  yourComments: 'yourComments',
}
